import { Box, ButtonNew as Button, Loader, Spacer, Text } from '@jfs/ui-new'
import { FC } from 'react'

interface EmptyViewProps {
  onRetry: () => void
  isLoading: boolean
  error?: any
  loadingMessage?: string
  emptyMessage?: string
  testID?: string
  loaderComponent?: any
  hide?: boolean
}
export const EmptyView: FC<EmptyViewProps> = ({
  onRetry,
  isLoading,
  error,
  loadingMessage = '',
  emptyMessage = '',
  testID = 'EmptyViewBox',
  hide = false,
  loaderComponent = <Loader type="small" color="PRIMARY_STORNG" />,
}: EmptyViewProps) => {
  if (hide) {
    return null
  }
  const [errors] = error?.networkError?.data?.errors ?? []
  const message = error ? (errors?.details ?? 'Something went wrong!') : isLoading ? loadingMessage : emptyMessage
  return (
    <Box
      onPress={error ? onRetry : undefined}
      justifyContent="center"
      alignItems="center"
      testID={testID}
      underlayColor="GRAY_BORDER">
      {isLoading && (
        <>
          {loaderComponent}
          <Spacer size={18}></Spacer>
        </>
      )}
      {message && (
        <Text fontSize={14} fontWeight="normal" color="BLACK">
          {message}
        </Text>
      )}
      {!!error && (
        <Box justifyContent="center" alignItems="center" marginTop={25}>
          <Button
            onPress={onRetry}
            type="primarySmall"
            title={'Retry'}
            paddingHorizontal={40}
            height={28}
            color="PRIMARY"
          />
        </Box>
      )}
    </Box>
  )
}
